import { render, staticRenderFns } from "./type7.vue?vue&type=template&id=1bb82fe4&scoped=true&"
import script from "./type7.vue?vue&type=script&lang=js&"
export * from "./type7.vue?vue&type=script&lang=js&"
import style0 from "./type7.vue?vue&type=style&index=0&id=1bb82fe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb82fe4",
  null
  
)

export default component.exports